import React from 'react';

import './CommonSwapIcon.css';

const CommonSwapIcon = () => (
  <div className="common-swap-icon__component">
    <div className="swap-icon" />
  </div>
);

export default CommonSwapIcon;
